export default __webpack_public_path__ + "static/mike-e78b31a1b4cfcd3a69eaaadf63d25fc1.png";